<template>
    <div class="newsDetail headNav">
        <div id="navTitle">
            <img class="black" @click="back" src="@/assets/images/template/a_top_return.png"/>
            <span>{{$route.query.title}}</span>
        </div>
        <div id="content">
            <div class="newsCon">
                <h1>{{detail.title}}</h1>
                <time>{{detail.ctime}}</time>
                <div class="newsItem" v-html="detail.content"></div>
            </div>
        </div>
    </div>
</template>
<script>
    require('@/assets/css/news.css');
    import moment from 'moment'
    import api from '@/plugins/api'
    import {mapState} from 'vuex'
    export default {
        name: "NewsDetail",
        computed: {
            ...mapState(['locale']),
        },
        data() {
            return {
                detail: {},
                langs:JSON.parse(process.env.VUE_APP_LANG)
            }
        },
        filters: {
            time(longTime) {
                return moment(new Date(longTime)).format("YYYY-MM-DD HH:mm");
            }
        },
        methods: {
            back() {
                this.$router.go(-1);
            },
            getNewDetail(id) {
                if (this.locale == "vn") {
                    this.langs = this.langs.vn
                } else {
                    this.langs = this.langs.en
                }
                api.detail(id,this.langs).then(res => {
                    if (res.data.code == 0) {
                        this.$bus.$emit('loading', true);
                        this.detail = res.data.data;
                    }
                })
            }
        },
        mounted() {
            let mainH = document.getElementById("main");
            mainH.classList.remove('mainFixed');
            this.getNewDetail(this.$route.query.id);
        },
    }
</script>

